import { Grid, Paper, withStyles } from "@material-ui/core";
import { Trans, useTranslations } from "adapters/i18n";
import React, { useEffect } from "react";
import { withRouter } from "react-router-dom";
import { DATE_FORMATS, DateUtils } from "shared/dateUtils";
import ModalAlerta from "../../shared/components/modalAlerta";
import ArrobaBalanceAvgDailyGainTable from "./arrobaBalanceAvgDailyGainTable";
import ArrobaBalanceHeader from "./arrobaBalanceHeader";
import ArrobaBalanceMovementsTable from "./arrobaBalanceMovementsTable";
import ArrobaBalanceSummaryTable from "./arrobaBalanceSummaryTable";
import ArrobaBalanceWeightEvolutionTable from "./arrobaBalanceWeightEvolutionTable";

const ArrobaBalancePage = ({
  conciliationStartDate,
  classes,
  dates,
  farmBalances,
  getBalanceData,
  getDates,
  history,
  onCloseMissingConciliationDateModal,
  showArrobaBalance,
  showInsufficientWeighingModal,
  showMissingConciliationDateModal,
}) => {
  const { t } = useTranslations();

  const formattedConciliationStartDate = DateUtils.parse(
    conciliationStartDate
  ).format(DATE_FORMATS["DD/MM/YYYY"]);

  useEffect(() => {
    const fetchData = async () => getDates();
    fetchData();
  }, []);

  const handleCloseMissingConciliationDateModal = () => {
    onCloseMissingConciliationDateModal();
    // Trocar para aba Categoria animal
    history.go(0);
  };

  if (!showArrobaBalance) {
    return (
      <ModalAlerta
        aoFechar={() => history.replace("/farol")}
        data-testid="blocked-arroba-balance-modal"
        descricao={
          <Trans
            i18nKey="arrobaBalance:blocked-arroba-balance-modal.description"
            components={{ bold: <strong /> }}
          />
        }
        exibeBotaoFechar={true}
        id="blocked-arroba-balance-modal"
      />
    );
  }

  if (!conciliationStartDate || showMissingConciliationDateModal) {
    return (
      <ModalAlerta
        aoFechar={handleCloseMissingConciliationDateModal}
        data-testid="missing-conciliation-date-modal"
        descricao={
          <Trans
            i18nKey="arrobaBalance:missing-conciliation-date-modal.description"
            components={{ bold: <strong /> }}
          />
        }
        exibeBotaoFechar={true}
        id="missing-conciliation-date-modal"
      />
    );
  }

  if (showInsufficientWeighingModal) {
    return (
      <ModalAlerta
        aoFechar={() => history.replace("/farol")}
        data-testid="insufficient-weighings-modal"
        descricao={
          <Trans
            i18nKey="arrobaBalance:insufficient-weighings-modal.description"
            components={{ p: <p />, bold: <strong /> }}
            values={{ date: formattedConciliationStartDate }}
          />
        }
        exibeBotaoFechar={false}
        id="insufficient-weighings-modal"
        titulo={t("arrobaBalance:arroba-balance")}
      />
    );
  }

  return (
    <Paper container data-testid="arroba-balance-page" className={classes.root}>
      <Grid container className={classes.containerPage}>
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={12}
          className={classes.headerWrapper}
        >
          <ArrobaBalanceHeader dates={dates} getBalanceData={getBalanceData} />
        </Grid>
        {Object.keys(farmBalances).length > 0 && (
          <>
            <Grid className={classes.totalTableWrapper}>
              <ArrobaBalanceSummaryTable farmBalances={farmBalances} />
            </Grid>
            <Grid className={classes.avgDailyGainTableWrapper}>
              <ArrobaBalanceAvgDailyGainTable farmBalances={farmBalances} />
            </Grid>
            <Grid className={classes.defaultTableWrapper}>
              <ArrobaBalanceWeightEvolutionTable
                categoryBalances={farmBalances.Categorias}
              />
            </Grid>
            <Grid className={classes.defaultTableWrapper}>
              <ArrobaBalanceMovementsTable
                movementBalances={farmBalances.EntradasSaidas}
              />
            </Grid>
          </>
        )}
      </Grid>
    </Paper>
  );
};

const styles = {
  root: {
    width: "100%",
    height: "100%",
    overflowX: "auto",
    zIndex: -1,
    padding: "4px 24px 4px 24px",
    flexgrow: 1,
    minHeight: window.innerHeight,
  },
  containerPage: {
    flexgrow: 1,
    height: "100%",
    backgroundColor: "#fff",
    margin: "0 auto",
    width: "90%",
  },
  headerWrapper: {
    width: "100%",
    height: "auto",
    marginBottom: "21px",
  },
  totalTableWrapper: {
    width: "100%",
    height: "auto",
    align: "center",
    marginBottom: "34px",
  },
  avgDailyGainTableWrapper: {
    width: "150%",
    height: "auto",
    align: "center",
    marginBottom: "34px",
  },
  defaultTableWrapper: {
    width: "100%",
    height: "auto",
    align: "center",
    marginBottom: "34px",
  },
};

export default withStyles(styles)(withRouter(ArrobaBalancePage));
